import styled from 'styled-components';

export const Container = styled.ul`
    --timeline-line-color: #cfd7da;
    --timeline-circle-size: 0.625rem;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    list-style-type: none;
`;

export const TimelineRecord = styled.li<{ dotColor: string }>`
    font-size: ${({ theme }) => theme.fontSizes[2]};
    letter-spacing: -0.15px;
    padding: 0 0 1.125rem calc(var(--timeline-circle-size) + 0.625rem);
    position: relative;
    max-height: 2.125rem;

    &::before {
        content: '';
        position: absolute;
        display: block;
        width: var(--timeline-circle-size);
        height: var(--timeline-circle-size);
        border-radius: 50%;
        left: 0;
        top: 0;
        transform: translateY(25%);
        background-color: ${({ dotColor }) => dotColor};
        z-index: 1;
    }

    &::after {
        content: '';
        left: calc(var(--timeline-circle-size) / 2 - 0.5px);
        top: 0;
        transform: translateY(25%);
        position: absolute;
        display: block;
        width: 1px;
        height: 2.125rem;
        background-color: var(--timeline-line-color);
    }

    &:last-child::after {
        display: none;
    }
`;

export const Bold = styled.span`
    font-weight: 700;
`;
